import { render } from "./SearchAreasFullscreen.vue?vue&type=template&id=5b2046aa&scoped=true"
import script from "./SearchAreasFullscreen.vue?vue&type=script&lang=js"
export * from "./SearchAreasFullscreen.vue?vue&type=script&lang=js"

import "./SearchAreasFullscreen.vue?vue&type=style&index=0&id=5b2046aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2046aa"]])

export default __exports__